import { useEffect, useRef } from "react";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import GallerySection from "@/components/GallerySection";
import BreakfastMenuSection from "@/components/BreakfastMenuSection";
import EveningMenuSection from "@/components/EveningMenuSection";
import LunchMenuSection from "@/components/LunchMenuSection";
import HolidayMenuSection from "@/components/HolidayMenuSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function HomePage() {
  const mainRef = useRef(null);

  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -40px 0px" }
    );

    const observeNew = () => {
      const els = mainRef.current?.querySelectorAll(".reveal:not(.visible)");
      els?.forEach((el) => io.observe(el));
    };

    observeNew();

    // Watch for dynamically added .reveal elements (async data loads)
    const mo = new MutationObserver(() => observeNew());
    if (mainRef.current) {
      mo.observe(mainRef.current, { childList: true, subtree: true });
    }

    return () => { io.disconnect(); mo.disconnect(); };
  }, []);

  return (
    <div data-testid="homepage" className="min-h-screen bg-[#02120D] grain" ref={mainRef}>
      <Header />
      <HeroSection />
      <AboutSection />
      <GallerySection />
      <BreakfastMenuSection />
      <EveningMenuSection />
      <LunchMenuSection />
      <HolidayMenuSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
